import React from 'react';
import StateButton from '../StateButton/StateButton';
import {ALLOCATION_STATE_CUSTOM, ALLOCATION_STATE_DEFAULT} from '../../containers/Allocations/Allocations';
import classes from './AllocationStateSelector.css';

const allocationStateSelector = (props) => {
    return (
        <div className={classes.AllocationStateSelector}>
            <label>Allocation:</label>
            <span>Enter the current allocations by selecting a default model or create a custom allocation.</span>
            <div className={classes.AllocationStateSelectorButtons}>
                <StateButton
                    label="Default"
                    isActive={props.isDefault}
                    click={()=>props.click(ALLOCATION_STATE_DEFAULT)}
                />
                <StateButton
                    label="Custom"
                    isActive={!props.isDefault}
                    click={()=>props.click(ALLOCATION_STATE_CUSTOM)}
                />
            </div>
        </div>
    );
};

export default allocationStateSelector;


// WEBPACK FOOTER //
// ./src/components/AllocationStateSelector/AllocationStateSelector.js